import { useNavigate } from 'react-router-dom';
import { Button, Card } from './ui';

// Turns a reverse-ordered set of pages into a path. Shown on the dashboard
// until the institute has launched its first test.
export default function SetupChecklist({ progress }) {
  const navigate = useNavigate();
  if (!progress) return null;

  const percent = Math.round((progress.completed / progress.total) * 100);

  return (
    <Card className="checklist-card">
      <div className="section-title">
        <div>
          <p className="eyebrow">Getting started</p>
          <h2>Set up your institute</h2>
          <p>{progress.completed} of {progress.total} steps done. Your students can take a test once all four are complete.</p>
        </div>
        <Button variant="secondary" onClick={() => navigate('/welcome')}>Guided setup</Button>
      </div>
      <div className="checklist-progress" role="progressbar" aria-valuenow={percent} aria-valuemin="0" aria-valuemax="100">
        <i style={{ width: `${percent}%` }} />
      </div>
      <ol className="checklist">
        {progress.steps.map((step, index) => (
          <li key={step.key} className={step.done ? 'done' : step.blocked ? 'blocked' : 'current'}>
            <span className="checklist-marker" aria-hidden="true">{step.done ? '✓' : index + 1}</span>
            <div className="checklist-body">
              <b>{step.title}</b>
              <p>{step.description}</p>
            </div>
            {!step.done && (
              <Button
                variant={step.blocked ? 'text' : 'primary'}
                disabled={step.blocked}
                onClick={() => navigate(step.to)}
              >
                {step.action}
              </Button>
            )}
          </li>
        ))}
      </ol>
    </Card>
  );
}
